// extracted by mini-css-extract-plugin
module.exports =  {"root":"PQceAQWfNvrpx0Zz_MaG"};